import React from 'react';
import PropTypes from 'prop-types';

export default function Column(props) {
	const { cellStyle, headerStyle, headerTitle, items, noShrink } = props;
	return (
		<div className={`flex-grow ${noShrink && 'flex-shrink-0'}`}>
			<div
				className={`px-4 h-12 flex items-center justify-center ${headerStyle}`}>
				<div>{headerTitle}</div>
			</div>
			{items.map((item, index) => (
				<div
					key={`${item} ${index + 1}`}
					className={`flex items-center justify-center h-12 px-4 my-2 ${cellStyle}`}>
					<div>{item}</div>
				</div>
			))}
		</div>
	);
}

Column.propTypes = {
	cellStyle: PropTypes.string,
	headerStyle: PropTypes.string,
	headerTitle: PropTypes.string,
	items: PropTypes.arrayOf(PropTypes.any),
	noShrink: PropTypes.bool
};
Column.defaultProps = {
	cellStyle: '',
	headerStyle: '',
	headerTitle: '',
	items: [],
	noShrink: false
};
